import moment from "moment";

export const displayValue = (value) => value === null || value === undefined || value === "" ? "--" : value;

export const getISTDate = date => {
  return date
    ? moment.utc(date).utcOffset(330).format('YYYY-MM-DD')
    : null
}
